import { types, getEnv } from '@invisr/mobx-state-tree'
import crudActions from './crud-actions'
export default types
  .model('DSDeps', {
    id: types.identifier,
    name: types.maybeNull(types.string)
  })
  .views(self => ({
    get dataSource () {
      return self
    },
    dataSourceDependencies () {
      let deps = []
      const s = self as any
      const env = getEnv(self)
      if (env?.dataSourceDependencies?.[self.id]) return env.dataSourceDependencies[self.id]
      if (s.mapping?.fieldSet) {
        deps.push(...Object.keys(s.mapping.fieldSet).filter(k => k !== self.id))
      }
      if (s.dataTransformer) {
        deps.push(...Object.keys(s.dataTransformer.dataSourceFieldSets))
      }
      return Array.from(new Set(deps)).filter(id => id !== self.id)
    }
  }))
  .actions(crudActions)
